import React, { FC, useState } from 'react'

import ColumnsForm from './ColumnsForm'
import { useDatasetColumns } from '../../../hooks/useDatasetColumns'
import { CreateDatasetColumnsParams } from 'tabs/data/api/columns'
import { alertError, alertSuccess } from 'api'

import { CButton } from 'tabs/data/components/CButton'
import * as S from './DatasetColumns.style'
import { CrossIcon } from 'uiKit/icons/CrossIcon'

type NewDatasetMetricsProps = {
  datasetId: string
  tableId: string
  hasItems: boolean
  onSubmit: () => Promise<void>
}

export const NewDatasetColumns: FC<NewDatasetMetricsProps> = ({ datasetId, tableId, hasItems, onSubmit }) => {
  const { createColumn } = useDatasetColumns()
  const [open, setOpen] = useState(false)

  const resetForm = () => {
    setOpen(false)
  }

  const handleCreate = async (params: CreateDatasetColumnsParams) => {
    try {
      const responce = await createColumn(datasetId, tableId, params)

      if (responce) {
        alertSuccess('Column created successfully.', 3000)
        resetForm()
        await onSubmit()
      }
    } catch (error) {
      switch (error.response.status) {
        case 404:
          throw alertError('The table that was already deleted')
        case 409:
          throw alertError('Provided Column name already exists')
        case 412:
          throw alertError('Error! Someone already made changes. Please reload page and try again.')
        default:
          throw alertError(error?.message || error || 'Error creating column')
      }
    }
  }

  return (
    <div style={hasItems ? { paddingTop: '1rem' } : { padding: '2rem 1rem 1rem', textAlign: 'center' }}>
      {open && (
        <S.CreateForm>
          <h5 style={{ textAlign: 'center' }}>New Column</h5>
          <S.IconWrap onClick={resetForm}>
            <CrossIcon color={'var(--color-spun-pearl-grey)'} />
          </S.IconWrap>

          <ColumnsForm rules={[]} type={null} synonyms={[]} onSubmit={handleCreate} onCancel={resetForm} />
        </S.CreateForm>
      )}

      {!open && (
        <CButton label={hasItems ? '+ Add Column' : 'Create Column'} color="primary" onClick={() => setOpen(true)} />
      )}
    </div>
  )
}
